import { __assign } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from 'clsx';
import React from 'react';
import { Drawer } from './drawer';
import styles from './styles.css.js';
import testutilStyles from './test-classes/styles.css.js';
export function NavigationPanel(_a) {
  var _b;
  var ariaLabels = _a.ariaLabels,
    footerHeight = _a.footerHeight,
    headerHeight = _a.headerHeight,
    isHidden = _a.isHidden,
    isMobile = _a.isMobile,
    navigation = _a.navigation,
    navigationDrawerWidth = _a.navigationDrawerWidth,
    navigationWidth = _a.navigationWidth,
    navigationOpen = _a.navigationOpen,
    onClick = _a.onClick,
    onNavigationToggle = _a.onNavigationToggle,
    panelHeightStyle = _a.panelHeightStyle,
    toggleRefs = _a.toggleRefs;
  return React.createElement("div", {
    className: styles['navigation-panel'],
    style: {
      width: navigationDrawerWidth
    }
  }, React.createElement("div", {
    className: clsx(styles['panel-wrapper-outer'], (_b = {}, _b[styles.mobile] = isMobile, _b[styles.open] = navigationOpen, _b)),
    style: __assign({}, isMobile ? {
      top: headerHeight,
      bottom: footerHeight
    } : panelHeightStyle)
  }, React.createElement(Drawer, {
    type: "navigation",
    isMobile: isMobile,
    width: navigationWidth,
    isOpen: navigationOpen,
    isHidden: isHidden,
    onToggle: onNavigationToggle,
    toggleRefs: toggleRefs,
    onClick: onClick,
    contentClassName: clsx(styles.navigation, testutilStyles.navigation),
    closeClassName: clsx(styles['navigation-close'], testutilStyles['navigation-close']),
    toggleClassName: clsx(styles['navigation-toggle'], testutilStyles['navigation-toggle']),
    topOffset: headerHeight,
    bottomOffset: footerHeight,
    ariaLabels: ariaLabels
  }, navigation)));
}